export { default as CardTopCustomer } from "./CardTopCustomer";
export { default as CardSellsByDay } from "./CardSellsByDay";
export { default as CardSellsByHour } from "./CardSellsByHour";
export { default as CardSellsByMonth } from "./CardSellsByMonth";
export { default as CardSellsTopEmployee } from "./CardSellsTopEmployee";
export { default as CardSellsTopCategories } from "./CardSellsTopCategories";
export { default as CardTopStoreVisitor } from "./CardTopVisitors";
export { default as CardAverageTicket } from "./CardAverageTicket";
export { default as CardNewClients } from "./CardNewClients";



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/index.js